import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Bell, ChevronDown, LogOut, Search, User as UserIcon } from 'lucide-react'
import { Avatar } from '@/components/ui/Avatar'
import { useAuthStore } from '@/stores/authStore'
import { AuthService } from '@/services/auth/AuthService'

// Ocultos temporariamente — trocar para true para reexibir.
const SHOW_SEARCH = false
const SHOW_NOTIFICATIONS = false

export function Topbar() {
  const user = useAuthStore((s) => s.user)
  const clearAuth = useAuthStore((s) => s.clearAuth)
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const dropRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (!dropRef.current?.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  async function handleSignOut() {
    try { await AuthService.signOut() } catch { /* segue */ }
    clearAuth()
    navigate('/login', { replace: true })
  }

  return (
    <header className="h-14 bg-white border-b border-gray-200 px-5 flex items-center gap-4 sticky top-0 z-30">
      {/* Search (visual, sem ação real ainda) — oculto temporariamente */}
      {SHOW_SEARCH && (
        <div className="relative w-72 max-w-full hidden md:block">
          <input
            type="search"
            placeholder="Buscar"
            className="w-full bg-gray-50 ring-1 ring-gray-200 rounded-lg pl-9 pr-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
          />
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[10px] text-gray-400 hidden md:inline">⌘K</span>
        </div>
      )}

      <div className="ml-auto flex items-center gap-2">
        {/* Notificações — oculto temporariamente */}
        {SHOW_NOTIFICATIONS && (
          <button
            className="relative p-2 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-700"
            title="Notificações"
          >
            <Bell size={16} />
            <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-rose-500" />
          </button>
        )}

        <div className="relative" ref={dropRef}>
          <button
            onClick={() => setOpen((v) => !v)}
            className="cursor-pointer flex items-center gap-2 px-2 py-1 rounded-lg hover:bg-gray-100"
          >
            <Avatar name={user?.name} size="sm" />
            <div className="hidden sm:flex flex-col items-start leading-tight">
              <span className="text-[12px] font-medium text-gray-800 max-w-[140px] break-words">
                {user?.name ?? '—'}
              </span>
              <span className="text-[10px] text-gray-500">{(user as { type?: string })?.type}</span>
            </div>
            <ChevronDown size={14} className="text-gray-400" />
          </button>

          {open && (
            <div className="absolute right-0 mt-2 w-56 bg-white rounded-md ring-1 ring-gray-200 overflow-hidden">
              <div className="px-4 py-3 border-b border-gray-100">
                <div className="text-sm font-medium text-gray-800 break-words">{user?.name}</div>
                <div className="text-[11px] text-gray-500 break-words">{(user as { email?: string })?.email}</div>
              </div>
              <button
                onClick={() => { setOpen(false); navigate('/profile') }}
                className="cursor-pointer w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 flex items-center gap-2"
              >
                <UserIcon size={14} /> Meu perfil
              </button>
              <button
                onClick={handleSignOut}
                className="cursor-pointer w-full px-4 py-2 text-sm text-left text-rose-600 hover:bg-rose-50 flex items-center gap-2"
              >
                <LogOut size={14} /> Sair
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
